module.exports = __webpack_public_path__ + "static/media/elsa.0e45d4bd.png";